module.exports = __webpack_public_path__ + "static/media/galerija_2018 (4).9081d5ce.jpg";